import { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { isValidInput } from "../utils/validations";
import { showError } from "../constants/toasts";

interface AddCategoryModalProps {
  open: boolean;
  value: string;
  loading: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  edit?: boolean;
  isSubCat?: boolean;
  handleSubmit: (name: string) => void;
  setCategoryName?: Dispatch<SetStateAction<string>> | null;
  facility?: boolean;
}

export default function AddCategory({
  open,
  value,
  loading,
  isSubCat = false,
  onClose,
  setOpen,
  handleSubmit,
  edit,
  setCategoryName,
  facility,
}: AddCategoryModalProps) {
  const [name, setName] = useState("");

  useEffect(() => {
    if (value?.length) {
      setName(value);
    }
  }, [value]);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>
              {edit
                ? `Edit ${isSubCat ? "Sub-" : ""}Category`
                : `Add ${isSubCat ? "Sub-" : ""}Category`}
            </h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>{`${isSubCat ? "Sub-" : ""}Category Name`}</label>
              <TextField
                value={name}
                onChange={(e) => {
                  if (isValidInput(e.target.value)) {
                    setName(e.target.value);
                  }
                }}
                placeholder={`Enter ${isSubCat ? "Sub-" : ""}Category Name`}
                fullWidth
                hiddenLabel
              ></TextField>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => {
                  if (!name?.length) {
                    showError("Name is required.");
                    return;
                  }
                  if (name?.length < 3) {
                    showError("Please enter a valid Name.");
                    return;
                  }

                  handleSubmit(name);
                  setName("");
                  if (setCategoryName) {
                    setCategoryName("");
                  }
                }}
                disabled={loading}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
